"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var create_svg_icon_1 = require("../../../utils/create-svg-icon");
exports.default = (0, create_svg_icon_1.createSvgIcon)(react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("path", { d: "M14.3531 2V9.63M9.64723 2V9.63M8.70605 2H15.2943", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
    react_1.default.createElement("path", { d: "M14.3529 9.875C17.6229 10.9426 20 14.177 20 18.0014C20 22.6958 16.4183 22.5014 12 22.5014C7.58172 22.5014 4 22.6958 4 18.0014C4 14.177 6.3771 10.9426 9.64706 9.875", strokeWidth: "2", strokeLinecap: "round" })), 'lab', { viewBox: '0 0 24 24', fill: 'none' });
